import React from 'react';
import { Card, CardBody } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const AmountCardSkeleton = () => {
  return (
    <Card className="card-height-100">
      <CardBody className="d-flex align-items-center ">
      <div className="d-flex align-items-center justify-content-start pe-3">
          {/* Skeleton for the icon */}
          <Skeleton  height={80} width={80} />
        </div>
        <div className="">
          
          <h3 className="text-dark m-0 mb-2">
            <Skeleton width={150} />
          </h3>
          <p className="fs-p-sm text-primary fw-medium mb-2">
            <Skeleton width={75} />
          </p>
         
         
        </div>
       
      </CardBody>
    </Card>
  );
};

export default AmountCardSkeleton;
